export const initialState = () => {
    return {
        gridSettings: {
            cellSize: 30,
            numberOfColumns: 6,
            numberOfRows: 7,
            isSelectingAnswer: false,
            currentSelectedCell: null, // null or { row, column }
            selectedCells: [] // [{ column, row }]
        },
        currentPuzzle: null,
        activeWordIndex: null, // used in admin
        foundWordIds: [],
        foundWordIdToAnimate: null,
        timers: {},
        showPopup: false,
        popupType: null,
        texts: []
    }
}
